import React, { RefObject } from 'react';
import classnames from 'classnames';
import PauseSVG from '../../../images/svg/pause';
import PlaySVG from '../../../images/svg/play';

import './audio-wave.scss';

interface IAudioWaveTrackProps {
    waveRef: RefObject<HTMLDivElement>;
    isPlaying: boolean;
    hasWave: boolean;
    seconds: number;
    playLabel: string;
    playable: boolean;
    disabled?: boolean;
    onToggle: () => void;
    leading?: React.ReactNode;
}

const formatTime = (seconds: number): string => {
    const safe = Math.max(0, Math.floor(seconds));
    const mins = Math.floor(safe / 60);
    const secs = safe % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
};

const AudioWaveTrack = ({
    waveRef,
    isPlaying,
    hasWave,
    seconds,
    playLabel,
    playable,
    disabled = false,
    onToggle,
    leading,
}: IAudioWaveTrackProps) => {
    const interactive = playable && !disabled;

    return (
        <div className={classnames('audio-wave__track', { 'audio-wave__track--playable': interactive })}>
            {playable && (
                <button
                    type='button'
                    className='audio-wave__hit'
                    onClick={onToggle}
                    disabled={!interactive}
                    aria-label={playLabel}
                    aria-pressed={isPlaying}
                />
            )}
            {leading}
            {!leading && playable && (
                <span className='audio-wave__lead audio-wave__lead--playback'>
                    {isPlaying ? <PauseSVG /> : <PlaySVG />}
                </span>
            )}
            <div
                ref={waveRef}
                className={classnames('audio-wave__wave', {
                    'audio-wave__wave--idle': !hasWave,
                    'audio-wave__wave--seek': interactive && hasWave,
                })}
            />
            <span className='audio-wave__time'>{formatTime(seconds)}</span>
        </div>
    );
};

export {
    AudioWaveTrack,
    IAudioWaveTrackProps,
};
